import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('delta2max.teaser');
    const { locale } = useRouter();
    const [fixH, setFixH] = useState(locale === 'au' ? 52 : 62);
    const [activeTab, setActiveTab] = useState(0);
    const tabs: any = [
        { text: t('fix_tab1'), id: '#dual-fast', key: 0 },
        { text: t('fix_tab2'), id: '#m-output', key: 1 },
        { text: t('fix_tab3'), id: '#durable-safe', key: 2 },
        { text: t('fix_tab4'), id: '#app-upgraded', key: 3 },
        { text: t('fix_tab5'), id: '#the-box', key: 4 },
    ];
    const handleClickTab = (k: number) => setActiveTab(k);

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeFunc = () => {
                const target = document.querySelector('.d2x-fix-tab .tabs-box') as HTMLUListElement;
                target.style.transition = 'left .4s ease';
                if (target.offsetWidth > window.innerWidth && activeTab >= 3) {
                    target.style.left = `${window.innerWidth - target.offsetWidth}px`;
                } else {
                    target.style.left = `${0}px`;
                }
            };
            resizeFunc();
            // window.addEventListener('resize', resizeFunc);
            // return () => window.removeEventListener('resize', resizeFunc);
        }
    }, [activeTab]);

    useEffect(() => {
        const targetB = document.querySelector('#dual-fast') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#dual-fast',
            triggerHook: 1,
            offset: '50%',
            duration: targetB?.offsetHeight,
            onEnter: () => setActiveTab(0),
        });

        const targetD = document.querySelector('#m-output') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#m-output',
            triggerHook: 1,
            offset: '50%',
            duration: targetD?.offsetHeight,
            onEnter: () => setActiveTab(1),
        });

        if (!['kr'].includes(locale)) {
            const targetL = document.querySelector('#durable-safe') as HTMLDivElement;
            AniContainer.create({
                triggerElement: '#durable-safe',
                triggerHook: 1,
                offset: '50%',
                duration: targetL?.offsetHeight,
                onEnter: () => setActiveTab(2),
            });
        }

        const targetM = document.querySelector('#app-upgraded') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#app-upgraded',
            triggerHook: 1,
            offset: '50%',
            duration: targetM?.offsetHeight,
            onEnter: () => setActiveTab(3),
        });

        const targetN = document.querySelector('#the-box') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#the-box',
            triggerHook: 1,
            offset: '50%',
            duration: targetN?.offsetHeight,
            onEnter: () => setActiveTab(4),
        });

        setTimeout(() => {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                const top = Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0;
                setFixH(top + locale === 'au' ? 52 : 62);
            }
        }, 800);
    }, []);

    return (
        <div className={`d2x-fix-tab ${css['d2x-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <>
                            {tab?.text && (
                                <a className={`tab ${activeTab === k ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.key)}>
                                    {tab?.text}
                                </a>
                            )}
                        </>
                    ))}
                </ul>
            </div>
        </div>
    );
}
